import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';
import {
  SubRolesCreateRequestDTO,
  SubRolesDTO,
  SubRolesUpdateRequestDTO,
  SubRolesReadByUserIdRequestDTO,
  SubRolesReadByIdRequestDTO,
  SubRolesUpdateIsDefaultRequestDTO,
  SubRolesDeleteRequestDTO,
  SubRolesMenuList,
  SubRolesReadBySoftwareIdRequestDTO
} from './SubRoles.interface';

import { SubRoles_create, SubRoles_delete, SubRoles_readById, SubRoles_readByRoleId, SubRoles_readBySoftwareId, SubRoles_readByUserId, SubRoles_update, SubRoles_updateIsDefault } from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class SubRolesService {

  constructor() { }

  http = inject(HttpClient);

  SubRoles_create(data: SubRolesCreateRequestDTO): Observable<SubRolesDTO> {
    return this.http.post<SubRolesDTO>(SubRoles_create, data);
  }

  SubRoles_update(data: SubRolesUpdateRequestDTO): Observable<SubRolesDTO> {
    return this.http.post<SubRolesDTO>(SubRoles_update, data);
  }

  SubRoles_readByUserId(data: SubRolesReadByUserIdRequestDTO): Observable<SubRolesMenuList> {
    return this.http.post<SubRolesMenuList>(SubRoles_readByUserId, data);
  }

  SSubRoles_readBySoftwareId(data: SubRolesReadBySoftwareIdRequestDTO): Observable<SubRolesDTO[]> {
    return this.http.post<SubRolesDTO[]>(SubRoles_readBySoftwareId, data);
  }

  SubRoles_readById(data: SubRolesReadByIdRequestDTO): Observable<SubRolesDTO> {
    return this.http.post<SubRolesDTO>(SubRoles_readById, data);
  }

  SubRoles_updateIsDefault(data: SubRolesUpdateIsDefaultRequestDTO): Observable<SubRolesDTO> {
    return this.http.post<SubRolesDTO>(SubRoles_updateIsDefault, data);
  }

  SubRoles_delete(data: SubRolesDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(SubRoles_delete, data);
  }

  // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
  // e.g. CompanyDetailComponent.apiConfigOverride.AM (company-subroles tab).
  // Omitted for every other caller - behaves exactly as before.
  SubRoles_readByRoleId(data:{roleId : number}, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<SubRolesMenuList> {
    return this.http.post<SubRolesMenuList>(resolveTenantUrl(SubRoles_readByRoleId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
  }

}
